/**
 * スマホ幅かどうか（FR-120・D-68）。
 *
 * ★ **console 内に置く**（`packages/ui` へ昇格させない）＝`formStyles.ts` と同じ方針。
 *   D-68 が対象にしているのは**卸コンソールの5画面だけ**で、liff（元からモバイル前提）と
 *   ops（PC 専用）には要らない。共有パッケージに置くと「3SPA 全部で使う部品」に見えて、
 *   本来 PC 前提のままでよい画面まで巻き込む力が働く。
 *
 * ★ **初期値を同期で取る**：`useState(false)` から effect で直すと、初回だけデスクトップの
 *   DOM（8〜9列のテーブル）が一瞬描かれてから消える。目には見えないが、E2E がその一瞬を
 *   掴んで不安定になる。SSR は無いので `matchMedia` を初期化子で呼んで問題ない。
 *
 * ★ 判定は 768px（0.4 の既定値）。inline style 方式なので `@media` ではなく**条件分岐で
 *   描き分ける**のが正攻法＝モバイルとデスクトップを**同時に DOM へ置かない**（置くと
 *   `data-testid` が2つになり、Playwright の strict mode で既存 E2E が 22 箇所落ちる）。
 */

import { useEffect, useState } from "react";

export const MOBILE_QUERY = "(max-width: 768px)";

/** ボトムバーの高さ（safe-area を除く）。sticky なバーのオフセットと main の余白で共有する。 */
export const MOBILE_TABBAR_HEIGHT = 60;

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    // 端末の回転・ウィンドウのリサイズで即追従（マウント時のズレも拾う）
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
